//
//
//
//
//
//
import { mdRender } from "../../functions/remarkable";
export default {
  name: 'FibQuizFlowHeader',
  props: {
    title: String,
    show: Boolean
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    }
  },
  methods: {
    renderText: function renderText(text) {
      return mdRender(text);
    }
  }
};